import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Spinner } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '../../../../../utils/httpProvider';
import { DANHGIA_HOSO_TIENSI_API } from '../../../../../utils/apiUrl';
import { 
    objectTrinhDoThiSinh, trinhDoThiSinhValue,
    objectTrinhDoNgoaiNgu, trinhDoNgoaiNguValue,
    objectDanhGiaDeCuong, danhGiaDeCuongValue,
    objectDanhGiaKinhNghiemNckh, danhGiaKinhNghiemNckhValue,
    objectDanhGiaCanBoHuongDan, danhGiaCanBoHuongDanValue,
    objectDanhGiaThoiGianCongTac, danhGiaThoiGianCongTacValue,
    objectDanhGiaCongVanThuGioiThieu, danhGiaCongVanThuGioiThieuValue,
    objectDanhGiaTinhTrangSucKhoe, danhGiaTinhTrangSucKhoeValue,
    objectTrangThaiDuyetHoSoNcs, trangThaiDuyetHoSoNcsValue
} from '../../../../../utils/define';

const DanhGiaHoSoTuyenSinhTienSiForm = ({ hoSoId, readOnly = false, refetchHoSo = () => {}, handleClose = () => {} }) => {
    const [saving, setSaving] = useState(false);
    const [formData, setFormData] = useState({
        trinhDoThiSinh: '',
        trinhDoNgoaiNgu: '',
        danhGiaDeCuong: '',
        danhGiaKinhNghiemNckh: '',
        danhGiaCanBoHuongDan: '',
        danhGiaThoiGianCongTac: '',
        danhGiaCongVanThuGioiThieu: '',
        danhGiaTinhTrangSucKhoe: '',
        trangThaiDuyet: ''
    });

    const { data: danhGiaRes, refetch: refetchDanhGia, isLoading } = useQuery(
        ['danhGiaHoSoTienSi', hoSoId], 
        () => Get(`${DANHGIA_HOSO_TIENSI_API.GET_BY_HOSO_ID}/${hoSoId}`),
        { 
            enabled: !!hoSoId,
            refetchOnWindowFocus: false 
        }
    );

    const danhGiaData = danhGiaRes?.data || danhGiaRes || null;

    const getEnumValue = (value, valueMap) => {
        if (value === null || value === undefined || value === '') return '';
        if (typeof value === 'number') return value;
        if (typeof value === 'string' && valueMap) {
            if (valueMap[value] !== undefined) return valueMap[value];
            const camelCase = value.charAt(0).toLowerCase() + value.slice(1);
            if (valueMap[camelCase] !== undefined) return valueMap[camelCase];
            const matchKey = Object.keys(valueMap).find(k => k.toLowerCase() === value.toLowerCase());
            if (matchKey) return valueMap[matchKey];
            if (!isNaN(value)) return parseInt(value);
        }
        return value;
    };

    useEffect(() => {
        if (danhGiaData && danhGiaData.id) {
            setFormData({
                trinhDoThiSinh: getEnumValue(danhGiaData.trinhDoThiSinh, trinhDoThiSinhValue),
                trinhDoNgoaiNgu: getEnumValue(danhGiaData.trinhDoNgoaiNgu, trinhDoNgoaiNguValue),
                danhGiaDeCuong: getEnumValue(danhGiaData.danhGiaDeCuong, danhGiaDeCuongValue),
                danhGiaKinhNghiemNckh: getEnumValue(danhGiaData.danhGiaKinhNghiemNckh, danhGiaKinhNghiemNckhValue),
                danhGiaCanBoHuongDan: getEnumValue(danhGiaData.danhGiaCanBoHuongDan, danhGiaCanBoHuongDanValue),
                danhGiaThoiGianCongTac: getEnumValue(danhGiaData.danhGiaThoiGianCongTac, danhGiaThoiGianCongTacValue),
                danhGiaCongVanThuGioiThieu: getEnumValue(danhGiaData.danhGiaCongVanThuGioiThieu, danhGiaCongVanThuGioiThieuValue),
                danhGiaTinhTrangSucKhoe: getEnumValue(danhGiaData.danhGiaTinhTrangSucKhoe, danhGiaTinhTrangSucKhoeValue),
                trangThaiDuyet: getEnumValue(danhGiaData.trangThaiDuyet, trangThaiDuyetHoSoNcsValue)
            });
        }
    }, [danhGiaData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value !== '' ? parseInt(value) : null }));
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            const dataToSave = {
                hoSoTuyenSinhId: hoSoId,
                ...formData
            };
            
            if (danhGiaData && danhGiaData.id) {
                // Đã có dữ liệu -> Update
                dataToSave.id = danhGiaData.id;
                await Put(DANHGIA_HOSO_TIENSI_API.UPDATE_ITEM, danhGiaData.id, dataToSave);
            } else {
                // Chưa có dữ liệu -> Create
                await Post(DANHGIA_HOSO_TIENSI_API.CREATE_ITEM, null, dataToSave);
            }

            toast.success('Lưu kết quả đánh giá hồ sơ thành công!');
            await refetchDanhGia();
            refetchHoSo();
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi lưu kết quả.');
        } finally {
            setSaving(false);
        }
    };

    const renderSelect = (label, name, options, required = false) => (
        <Form.Group className="mb-3">
            <Form.Label className="font-weight-bold">{label} {required && <span className="text-danger">*</span>}</Form.Label>
            <Form.Control 
                as="select"
                name={name}
                value={formData[name] === null ? '' : formData[name]}
                onChange={handleChange}
                disabled={readOnly}
                className={formData[name] !== '' && formData[name] !== null ? 'font-weight-bold text-primary' : ''}
            >
                <option value="">-- Chưa đánh giá --</option>
                {options.map((opt, i) => (
                    <option key={i} value={opt.value}>{opt.label}</option>
                ))}
            </Form.Control>
        </Form.Group>
    );

    if (isLoading) return <div className="text-center p-3"><Spinner animation="border" variant="primary" /></div>;

    return (
        <div className="bg-white p-3 rounded border">
            <h5 className="font-weight-bold text-primary mb-4 border-bottom pb-2">
                <i className="fas fa-clipboard-check mr-2"></i>Phiếu Đánh Giá Hồ Sơ Tuyển Sinh
            </h5>
            <Row>
                <Col md={6}>
                    {renderSelect("Trình độ thí sinh", "trinhDoThiSinh", objectTrinhDoThiSinh)}
                    {renderSelect("Trình độ ngoại ngữ", "trinhDoNgoaiNgu", objectTrinhDoNgoaiNgu)}
                    {renderSelect("Đề cương nghiên cứu", "danhGiaDeCuong", objectDanhGiaDeCuong)}
                    {renderSelect("Kinh nghiệm NCKH", "danhGiaKinhNghiemNckh", objectDanhGiaKinhNghiemNckh)}
                </Col>
                <Col md={6}>
                    {renderSelect("Cán bộ hướng dẫn", "danhGiaCanBoHuongDan", objectDanhGiaCanBoHuongDan)}
                    {renderSelect("Thời gian công tác", "danhGiaThoiGianCongTac", objectDanhGiaThoiGianCongTac)}
                    {renderSelect("Công văn cử đi dự tuyển/Thư giới thiệu", "danhGiaCongVanThuGioiThieu", objectDanhGiaCongVanThuGioiThieu)}
                    {renderSelect("Tình trạng sức khỏe", "danhGiaTinhTrangSucKhoe", objectDanhGiaTinhTrangSucKhoe)}
                </Col>
            </Row>
            <hr />
            <Row>
                <Col md={12}>
                    <div className="p-3 bg-light rounded border">
                        {renderSelect("KẾT LUẬN DUYỆT HỒ SƠ", "trangThaiDuyet", objectTrangThaiDuyetHoSoNcs)}
                    </div>
                </Col>
            </Row>
            
            {!readOnly && (
                <div className="text-right mt-4">
                    <Button variant="primary" onClick={handleSave} disabled={saving}>
                        {saving ? <Spinner size="sm" animation="border" className="mr-1" /> : <i className="fas fa-save mr-1"></i>}
                        Lưu kết quả
                    </Button>
                </div>
            )}
        </div>
    );
}

export default DanhGiaHoSoTuyenSinhTienSiForm;
